import { cn } from "@/lib/utils";

function SecondaryText({
  children,
  className,
  onClick,
}: {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}) {
  return (
    <div
      onClick={onClick}
      className={cn(
        "text-text-secondary",
        onClick ? "cursor-pointer hover:underline" : "",
        className
      )}
    >
      {children}
    </div>
  );
}

export default SecondaryText;
